import moment from 'moment';
import _ from 'lodash';
import { CreateEditOrderEnum, ManageProcessOrderEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import {
  CreateEditDupOrderEnum,
  StatusOptionEnum,
  TypeOptionEnum,
  ManageProcessOrderStatusEnum,
  BracketTypeEnum,
} from 'Common/Constants/Enumeration/ManageProcessOrderEnum';
import {
  dollarCalculation,
  quantityCalculation,
  weightCalculation,
} from 'Common/FormHelper';

export const basicURL = '/manageprocessorder';
export const getSaveObject = (
  values,
  id,
  IsNewEditDup,
  selectedOrderDetail
) => {
  let saveObj = {
    Id: IsNewEditDup === CreateEditDupOrderEnum.EDIT ? id : 0,
    SiteId: values[CreateEditOrderEnum.SiteId],
    TransactionDT: values[CreateEditOrderEnum.TransactionDT]
      ? moment(values[CreateEditOrderEnum.TransactionDT]).format(
          DATE_FORMAT_FOR_SERVER
        )
      : null,
    Comments: values[CreateEditOrderEnum.Comments],
    Status: StatusOptionEnum.OPEN,
    Type: TypeOptionEnum.ORDER,
    TransactionDetail: [],
  };
  _.forEach(values[CreateEditOrderEnum.OrderItemsInfo], item => {
    if (item.PriQty || item.SecQty) {
      let itemModified =
        selectedOrderDetail &&
        selectedOrderDetail.ItemList &&
        _.find(
          selectedOrderDetail.ItemList,
          orderItem => orderItem.ItemCode === item.ItemCode
        );
      const obj = {
        Id:
          IsNewEditDup === CreateEditDupOrderEnum.EDIT
            ? itemModified
              ? itemModified.Id
              : item.Id
            : CreateEditDupOrderEnum.NEW,
        ItemId: item[CreateEditOrderEnum.ItemId],
        ItemCode: item[CreateEditOrderEnum.ItemCode],
        ItemDescription: item[CreateEditOrderEnum.Description],
        Unit: item[CreateEditOrderEnum.Unit],
        SecondaryUnit: item[CreateEditOrderEnum.SecondaryUnit],
        QtyPerUnit: item[CreateEditOrderEnum.QtyPerUnit],
        PrimaryQty: item[CreateEditOrderEnum.PriQty],
        SecondaryQty: item[CreateEditOrderEnum.SecQty],
        PrimaryPrice: item[CreateEditOrderEnum.PrimaryPrice],
      };
      saveObj.TransactionDetail.push(obj);
    }
  });
  return saveObj;
};

export const getTotalMerchandiseAmount = orderItemsInfo => {
  let CalculateCostPerServing = 0,
    totalValue = 0;
  if (orderItemsInfo && orderItemsInfo.length) {
    totalValue = _.reduce(
      orderItemsInfo,
      (total, prevItem) => {
        if (
          !prevItem.BracketType ||
          prevItem.BracketType === BracketTypeEnum.None
        ) {
          if ((prevItem.PriQty || prevItem.SecQty) && +prevItem.QtyPerUnit) {
            if (+prevItem.PrimaryPrice) {
              CalculateCostPerServing =
                prevItem.PrimaryPrice / prevItem.QtyPerUnit;
            }
          }
          if (prevItem.PriQty && !isNaN(prevItem.PriQty)) {
            total += prevItem.PrimaryPrice * +prevItem.PriQty;
          }
          if (prevItem.SecQty && !isNaN(prevItem.SecQty)) {
            total += CalculateCostPerServing * prevItem.SecQty;
          }
        } else if (prevItem.BracketType === BracketTypeEnum.Dollars) {
          total += dollarCalculation(
            prevItem,
            +prevItem.BracketPricingDetails[0].Price
          );
        } else if (prevItem.BracketType === BracketTypeEnum.Quantity) {
          total += quantityCalculation(prevItem);
        } else if (prevItem.BracketType === BracketTypeEnum.Weight) {
          total += weightCalculation(prevItem);
        }
        return total;
      },
      0
    );
  }
  return totalValue.toFixed(4);
};

export const validateInput = newValue => {
  if (newValue.startsWith('-')) {
    const qty = newValue.split('-')[1].replace(/-/g, '');
    newValue = '-' + qty;
  } else {
    newValue = newValue.replace(/-/g, '');
  }
  const indexOfDecimal = newValue.indexOf('.');
  if (indexOfDecimal > 1) {
    const prevValue = newValue.substr(0, indexOfDecimal);
    const value = newValue
      .substr(indexOfDecimal, newValue.length)
      .replace(/\./g, '');
    newValue = prevValue + '.' + value;
  }
  return newValue;
};

export const getClosedOrderedItem = (orderData, selectedOrderIds) => {
  let filterOrderObj = _.filter(orderData, order => {
    return selectedOrderIds.indexOf(order[ManageProcessOrderEnum.Id]) !== -1;
  });
  filterOrderObj = _.filter(filterOrderObj, {
    Status: ManageProcessOrderStatusEnum.CLOSED,
  });
  return filterOrderObj;
};

export const makeOrderTypes = (OrderTypeDetails, orderTypesData) => {
  const orderData = [];
  if (
    OrderTypeDetails &&
    Array.isArray(OrderTypeDetails) &&
    OrderTypeDetails.length
  ) {
    OrderTypeDetails.forEach(type => {
      if (Number.isInteger(type) && +type) {
        orderData.push(
          orderTypesData.find(item => {
            return item.Id === +type;
          })
        );
      } else if (
        !Number.isInteger(type) &&
        !type.includes(OrderTypeEnum.NewType)
      ) {
        orderData.push({
          Id: 0,
          Description: type,
        });
      }
    });
  }
  return orderData;
};

export const StorageLocationEnum = {
  Unassigned: -1,
  Empty: 0,
};

export const OrderTypeEnum = {
  NewType: 'newType:',
};

export const ManageProcessOrderPrintOptions = [
  { value: 'ItemCode', label: 'Item Code' },
  { value: 'Description', label: 'Item Description' },
];



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/helper/index.js